import PropTypes from 'prop-types';

const containerTypes = {
  header: {
    css: 'flex flex-row items-start justify-between heading-content-margin',
  },
  'max-3XL': {
    css: 'max-w-3xl px-4 md:px-8',
  },
  widest: {
    css: 'max-w-8xl px-4 md:px-8',
  },
};

/* Customize `max-w-8xl` as 95rem in tailwind.config.js. 
The largest in Tailwind defaults is `max-w-7xl` as 80rem. */
const Container = ({ type, isCentered, children }) => {
  const contentPosition = isCentered ? 'mx-auto' : '';
  let containerClass = containerTypes[type].css;
  containerClass += ` ${contentPosition}`;

  return <div className={containerClass}>{children}</div>;
};

Container.defaultProps = {
  isCentered: false,
  type: 'widest',
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
  isCentered: PropTypes.bool,
  type: PropTypes.oneOf(['header', 'max-3XL', 'widest']),
};

export default Container;
